// Touch is the primary input: phone, tablet, or a 2-in-1 folded into tablet mode.
// A touchscreen laptop reports its trackpad as a fine pointer, so it is excluded.
export function isTouchPrimaryDevice(): boolean {
  return (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(pointer: coarse) and (hover: none)').matches
  );
}
